<template>
  <div class="store">
    <div class="store-wrap">
      <div class="store-steps">
        <div class="store-steps__list">
          <div class="store-steps__item" :class="{ 'active': step >= 1 }">1</div>
          <div class="store-steps__item" :class="{ 'active': step >= 2 }">2</div>
          <div class="store-steps__item" :class="{ 'active': step >= 3 }">3</div>
          <div class="store-steps__item" :class="{ 'active': step >= 4 }">4</div>
        </div>
        <div class="store-steps__title">
          <p v-if="step === 1">{{ $t('chooseOffer') }}</p>
          <p v-if="step === 2">{{ $t('enterQuantity') }}
            <span>Total amount - <strong>${{ totalAmount }}</strong></span>
            <span>Total count - <strong>{{ count }}</strong></span>
          </p>
          <p v-if="step === 3">{{ $t('choosePaymentType') }}
            <span>Total amount - <strong>${{ totalAmount }}</strong></span>
            <span>Total count - <strong>{{ count }}</strong></span>
          </p>
          <p v-if="step === 4">
            <span v-if="paymentType === 'creditCard'">{{ $t('paymentDetail') }}</span>
            <span v-else>{{ $t('confirmPayment') }}</span>
            <span>Total amount - <strong>${{ totalAmount }}</strong></span>
            <span>Total count - <strong>{{ count }}</strong></span>
          </p>
        </div>
      </div>
      <div class="store-packages" v-if="step === 1">
        <div class="store-list" v-if="list.length">
          <StoreItem @selectOffer="selectOffer($event)" v-for="item in list" :key="item.id" :item="item" />
        </div>
        <div class="store-empty" v-if="!list.length && !getListLoading">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" viewBox="0 0 512 512" xml:space="preserve">
            <path style="fill:#969696;" d="M373.107,8.17h-32.681v441.191h32.681c17.975,0,32.681-14.706,32.681-32.681V40.851  C405.788,22.877,391.081,8.17,373.107,8.17z"/>
            <path style="fill:#B9B9B9;" d="M309.633,256.001l63.474-215.149c0-17.975-14.706-32.681-32.681-32.681h-32.681l-78.979,22.982  L149.787,8.17H84.425c-17.975,0-32.681,14.706-32.681,32.681v375.83c0,17.974,14.706,32.681,32.681,32.681h256.001  c17.975,0,32.681-14.706,32.681-32.681L309.633,256.001z"/>
            <polygon style="fill:#D5F6F5;" points="373.107,40.851 373.107,416.681 340.426,416.681 275.064,228.766 340.426,40.851 "/>
            <rect x="84.425" y="40.851" style="fill:#FFFFFF;" width="256.001" height="375.831"/>
            <polygon style="fill:#FEDC3D;" points="307.745,8.17 307.745,62.638 275.064,62.638 253.277,35.404 275.064,8.17 "/>
            <rect x="149.787" y="8.17" style="fill:#FFF1B1;" width="125.277" height="54.468"/>
            <path style="fill:#B9B9B9;" d="M307.745,193.362H149.787c-4.513,0-8.17-3.658-8.17-8.17c0-4.512,3.657-8.17,8.17-8.17h157.958   c4.513,0,8.17,3.658,8.17,8.17C315.915,189.704,312.257,193.362,307.745,193.362z"/>
            <path style="fill:#B9B9B9;" d="M307.745,236.937H149.787c-4.513,0-8.17-3.658-8.17-8.17s3.657-8.17,8.17-8.17h157.958   c4.513,0,8.17,3.658,8.17,8.17S312.257,236.937,307.745,236.937z"/>
            <path style="fill:#B9B9B9;" d="M228.766,280.511h-78.979c-4.513,0-8.17-3.658-8.17-8.17s3.657-8.17,8.17-8.17h78.979   c4.513,0,8.17,3.658,8.17,8.17S233.278,280.511,228.766,280.511z"/>
            <path style="fill:#FE5F1A;" d="M351.319,285.957V503.83c60.166,0,108.936-48.771,108.936-108.936S411.485,285.957,351.319,285.957z"/>
            <path style="fill:#FE834D;" d="M351.319,285.957c42.115,0,76.255,48.771,76.255,108.936S393.434,503.83,351.319,503.83  c-60.166,0-108.936-48.771-108.936-108.936S291.154,285.957,351.319,285.957z"/>
            <path style="fill:#FFFFFF;" d="M401.389,421.854l-26.961-26.961l26.961-26.961c6.382-6.382,6.382-16.727,0-23.109  c-6.381-6.382-16.727-6.382-23.109,0l-26.961,26.961l-26.961-26.961c-6.382-6.381-16.727-6.381-23.109,0  c-6.382,6.382-6.382,16.727,0,23.109l26.961,26.961l-26.961,26.961c-6.382,6.382-6.382,16.727,0,23.109s16.727,6.382,23.109,0  l26.961-26.961l26.961,26.961c6.382,6.382,16.727,6.382,23.109,0C407.77,438.581,407.769,428.236,401.389,421.854z"/>
            <path d="M220.601,441.191H84.425c-13.515,0-24.511-10.995-24.511-24.511V40.851c0-13.515,10.995-24.511,24.511-24.511h57.192v73.532  c0,13.515,10.996,24.511,24.511,24.511h125.277c13.515,0,24.511-10.996,24.511-24.511V16.34h57.192  c13.515,0,24.511,10.996,24.511,24.511v223.325c0,4.512,3.657,8.17,8.17,8.17s8.17-3.658,8.17-8.17V40.851  C413.958,18.326,395.631,0,373.107,0H84.425C61.899,0,43.574,18.326,43.574,40.851v375.83c0,22.526,18.325,40.851,40.851,40.851  h136.177c4.513,0,8.17-3.658,8.17-8.17S225.114,441.191,220.601,441.191z M291.404,98.043H166.127c-4.506,0-8.17-3.666-8.17-8.17  V70.809h141.617v19.064C299.575,94.377,295.909,98.043,291.404,98.043z M299.575,54.468H157.957V16.34h141.617V54.468z"/>
            <path d="M116.561,49.021c4.513,0,8.17-3.658,8.17-8.17s-3.658-8.17-8.17-8.17H84.425c-4.513,0-8.17,3.658-8.17,8.17v375.83  c0,4.512,3.657,8.17,8.17,8.17h126.953c4.513,0,8.17-3.658,8.17-8.17s-3.657-8.17-8.17-8.17H92.595V49.021H116.561z"/>
            <path d="M373.107,263.123c4.513,0,8.17-3.658,8.17-8.17V40.851c0-4.512-3.657-8.17-8.17-8.17h-32.681c-4.513,0-8.17,3.658-8.17,8.17  s3.657,8.17,8.17,8.17h24.511v205.931C364.936,259.465,368.593,263.123,373.107,263.123z"/>
            <path d="M351.319,277.787c-64.572,0-117.107,52.533-117.107,117.107S286.747,512,351.319,512s117.107-52.533,117.107-117.107  S415.891,277.787,351.319,277.787z M351.319,495.66c-55.563,0-100.766-45.203-100.766-100.766s45.203-100.766,100.766-100.766  s100.766,45.203,100.766,100.766S406.882,495.66,351.319,495.66z"/>
            <path d="M414.345,356.379c0-6.547-2.55-12.703-7.179-17.332c-4.63-4.63-10.785-7.179-17.332-7.179s-12.702,2.55-17.332,7.179  l-21.183,21.183l-21.183-21.183c-4.63-4.63-10.785-7.179-17.332-7.179s-12.702,2.55-17.331,7.179  c-4.63,4.63-7.18,10.785-7.18,17.333c0,6.547,2.55,12.702,7.179,17.332l21.184,21.183l-21.184,21.183  c-4.629,4.63-7.179,10.785-7.179,17.332s2.55,12.703,7.179,17.332c4.63,4.63,10.785,7.179,17.332,7.179s12.702-2.55,17.332-7.179  l21.183-21.183l21.183,21.183c4.63,4.63,10.785,7.179,17.332,7.179s12.702-2.55,17.331-7.179c4.63-4.63,7.18-10.785,7.18-17.333  c0-6.547-2.55-12.702-7.179-17.332l-21.184-21.183l21.184-21.183C411.794,369.081,414.345,362.926,414.345,356.379z   M395.611,362.157l-26.961,26.961c-1.532,1.532-2.392,3.61-2.392,5.777s0.861,4.245,2.392,5.777l26.961,26.961  c1.544,1.544,2.393,3.595,2.393,5.778s-0.85,4.234-2.393,5.777c-1.543,1.544-3.595,2.393-5.777,2.393s-4.234-0.85-5.777-2.393  l-26.961-26.961c-1.596-1.595-3.688-2.393-5.778-2.393c-2.09,0-4.182,0.797-5.778,2.393l-26.961,26.961  c-1.543,1.544-3.595,2.393-5.777,2.393c-2.182,0-4.234-0.85-5.778-2.393c-1.543-1.543-2.392-3.594-2.392-5.777  s0.85-4.234,2.393-5.778l26.961-26.961c1.532-1.532,2.392-3.61,2.392-5.777s-0.861-4.245-2.392-5.777l-26.961-26.961  c-1.544-1.544-2.393-3.595-2.393-5.778c0-2.183,0.85-4.234,2.393-5.777c1.543-1.544,3.595-2.393,5.777-2.393  c2.182,0,4.234,0.85,5.777,2.393l26.961,26.961c3.192,3.191,8.364,3.191,11.555,0l26.961-26.961  c1.543-1.544,3.595-2.393,5.777-2.393c2.182,0,4.234,0.85,5.778,2.393c1.543,1.543,2.392,3.594,2.392,5.777  C398.003,358.562,397.154,360.613,395.611,362.157z"/>
          </svg>
        </div>
        <transition name="fade" mode="out-in">
          <div class="store-packages__loader" v-if="getListLoading">
            <Loader />
          </div>
        </transition>
      </div>
      <div class="store-form__wrap" v-if="step === 2">
        <div class="store-form__count">
          <button class="dec" @click="decrementCount">-</button>
          <input type="number" v-model="count" @change="updateCount">
          <button class="inc" @click="incrementCount">+</button>
        </div>
        <button class="store-form__next" :disabled="!count" @click="setCount">{{ $t('buttonAdd') }}</button>
        <div class="store-form__back">
          <a href="#" class="store-form__action-back back-button" @click.prevent="goToOffers">
            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 52 52"
                 enable-background="new 0 0 52 52" xml:space="preserve">
            <path d="M48.6,23H15.4c-0.9,0-1.3-1.1-0.7-1.7l9.6-9.6c0.6-0.6,0.6-1.5,0-2.1l-2.2-2.2c-0.6-0.6-1.5-0.6-2.1,0  L2.5,25c-0.6,0.6-0.6,1.5,0,2.1L20,44.6c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1l-9.6-9.6C14,30.1,14.4,29,15.3,29  h33.2c0.8,0,1.5-0.6,1.5-1.4v-3C50,23.8,49.4,23,48.6,23z"/>
          </svg>
            {{ $t('back') }}
          </a>
        </div>
      </div>
      <div class="store-form__wrap" v-if="step === 3">
        <div class="store-form__radio">
          <div class="store-form__radio-list">
            <Radio value="creditCard" name="creditCard" class="radio" v-model="paymentType">{{ $t('payViaCreditCard') }}</Radio>
            <Radio value="credit" name="credit" class="radio" v-model="paymentType">
              {{ $t('payViaCredit') }}
              <span v-tooltip="{
                 trigger: 'hover',
                 content: $t('creditCardMessage')}">
                <svg data-v-5265ab94="" xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="-1 0 19 19" class="cf-icon-svg"><path data-v-5265ab94="" d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zM9.64 5.78a1.136 1.136 0 1 0-1.136 1.135A1.136 1.136 0 0 0 9.64 5.781zm-.344 2.884a.792.792 0 1 0-1.583 0v5.203a.792.792 0 0 0 1.583 0z"></path></svg>
              </span>
            </Radio>
          </div>
          <div class="store-form__radio-action">
            <button class="store-form__next" @click="setNextStep(4)">{{ $t('pay') }}</button>
            <div class="store-form__back">
              <a href="#" class="store-form__action-back back-button" @click.prevent="changePreviousStep(2)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 52 52"
                     enable-background="new 0 0 52 52" xml:space="preserve">
            <path
              d="M48.6,23H15.4c-0.9,0-1.3-1.1-0.7-1.7l9.6-9.6c0.6-0.6,0.6-1.5,0-2.1l-2.2-2.2c-0.6-0.6-1.5-0.6-2.1,0  L2.5,25c-0.6,0.6-0.6,1.5,0,2.1L20,44.6c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1l-9.6-9.6C14,30.1,14.4,29,15.3,29  h33.2c0.8,0,1.5-0.6,1.5-1.4v-3C50,23.8,49.4,23,48.6,23z"/>
          </svg>
                {{ $t('back') }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="store-form__wrap" v-if="step === 4">
        <form class="store-form" @submit.prevent="onSubmit" v-if="paymentType === 'creditCard'">
          <div class="store-form__row">
            <BaseInput
              v-model="name"
              :label="$t('formCardName')"
              :placeholder="$t('formCardName')"
              @input="$v.name.$touch()"
              :invalid="$v.name.$error"
              :error="$t('errorEmptyField')"
            />
          </div>
          <div class="store-form__row">
            <label>
              {{ $t('formCardNumber') }}
              <card-number class="stripe-input"
                           ref="cardNumber"
                           :stripe="$options.stripeApiKey"
                           :options="stripeOptions"
                           @change="number = $event.complete"
              />
            </label>
          </div>
          <div class="store-form__row">
            <label>
              {{ $t('expireDate') }}
              <card-expiry class="stripe-input"
                           ref="cardExpiry"
                           :stripe="$options.stripeApiKey"
                           :options="stripeOptions"
                           @change="expiry = $event.complete"
              />
            </label>
          </div>
          <div class="store-form__row">
            <label>
              {{ $t('formCvv') }}
              <card-cvc class="stripe-input"
                        ref="cardCvc"
                        :stripe="$options.stripeApiKey"
                        :options="stripeOptions"
                        @change="cvc = $event.complete"
              />
            </label>
          </div>
          <!-- error  -->
          <p v-if="$v.$error" class="form--error">
            {{ $t('errorStripe') }}
          </p>
          <p v-if="errorResp" class="form--error">
            {{ errorResp }}
          </p>
          <div class="store-form__action">
            <div class="store-form__back">
              <a href="#" class="store-form__action-back back-button" @click.prevent="changePreviousStep(3)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 52 52"
                     enable-background="new 0 0 52 52" xml:space="preserve">
              <path d="M48.6,23H15.4c-0.9,0-1.3-1.1-0.7-1.7l9.6-9.6c0.6-0.6,0.6-1.5,0-2.1l-2.2-2.2c-0.6-0.6-1.5-0.6-2.1,0  L2.5,25c-0.6,0.6-0.6,1.5,0,2.1L20,44.6c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1l-9.6-9.6C14,30.1,14.4,29,15.3,29  h33.2c0.8,0,1.5-0.6,1.5-1.4v-3C50,23.8,49.4,23,48.6,23z"/>
            </svg>
                {{ $t('back') }}
              </a>
            </div>
            <BaseButton :loading="loading" :disabled="!isComplete">{{ $t('pay') }}</BaseButton>
          </div>
        </form>
        <div class="store-finish" v-if="paymentType === 'credit'">
          <BaseButton :loading="loading" @click="getFreeOffer">{{ $t('pay') }}</BaseButton>
          <div class="store-form__back">
            <a href="#" class="store-form__action-back back-button" @click.prevent="changePreviousStep(3)">
              <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="800px" height="800px" viewBox="0 0 52 52"
                   enable-background="new 0 0 52 52" xml:space="preserve">
                <path d="M48.6,23H15.4c-0.9,0-1.3-1.1-0.7-1.7l9.6-9.6c0.6-0.6,0.6-1.5,0-2.1l-2.2-2.2c-0.6-0.6-1.5-0.6-2.1,0  L2.5,25c-0.6,0.6-0.6,1.5,0,2.1L20,44.6c0.6,0.6,1.5,0.6,2.1,0l2.1-2.1c0.6-0.6,0.6-1.5,0-2.1l-9.6-9.6C14,30.1,14.4,29,15.3,29  h33.2c0.8,0,1.5-0.6,1.5-1.4v-3C50,23.8,49.4,23,48.6,23z"/>
              </svg>
              {{ $t('back') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import StoreItem from '@/components/BDTLStoreItem.vue'
import { CardCvc, CardExpiry, CardNumber } from 'vue-stripe-elements-plus'
import { required } from 'vuelidate/lib/validators'
import Loader from '@/components/Spinner'
import { Radio } from 'vue-checkbox-radio'
import moment from 'moment'

const STRIPE_API_KEY = process.env.VUE_APP_STRIPE_API_KEY

export default {
  name: 'BDTLStore',
  components: {
    StoreItem,
    CardNumber,
    CardExpiry,
    CardCvc,
    Loader,
    Radio
  },
  stripeApiKey: STRIPE_API_KEY,
  data () {
    return {
      paymentType: 'creditCard',
      packageOfferId: null,
      count: 0,
      resultList: [],
      step: 1,
      getListLoading: false,
      packageId: null,
      loading: false,
      stripeOptions: {
        style: {
          base: {
            fontFamily: "'Montserrat', sans-serif",
            color: '#1a1a1a',
            fontSize: '16px',
            '::placeholder': {
              color: '#888888'
            }
          }
        }
      },
      name: null,
      number: false,
      expiry: false,
      cvc: false,
      submitting: false,
      errorResp: null,
      totalAmount: 0,
      currentOfferPrice: 0
    }
  },
  validations: {
    name: { required },
    number: {
      checked: value => value === true
    },
    expiry: {
      checked: value => value === true
    },
    cvc: {
      checked: value => value === true
    }
  },
  computed: {
    ...mapGetters({
      offersList: 'agents/offersList',
      user: 'auth/user',
      packageById: 'entities/packages/find'
    }),
    list () {
      let result
      if (this.offersList.length) {
        result = this.offersList.filter((item) => moment().isBefore(item.endDate))
      } else {
        result = []
      }
      return result
    },
    isComplete () {
      return this.number && this.expiry && this.cvc && this.name
    },
    isUserBDTLAgent () {
      return this.getPackageById(this.user.package) === 'BDTL Agent' || this.getPackageById(this.user.package) === 'BDTL Agency'
    }
  },
  watch: {
    number: 'moveFocus',
    expiry: 'moveFocus',
    cvc: 'moveFocus',
    user: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.checkAgentPermission()
        }
      }
    },
    count: {
      immediate: true,
      handler () {
        this.totalAmount = this.count * this.currentOfferPrice
      }
    }
  },
  created () {
    if (!this.offersList.length) {
      this.getList()
    }
  },
  methods: {
    ...mapActions({
      updateSettings: 'auth/updateSettings',
      fetchOffersList: 'agents/fetchOffersList',
      buyBDTLOffers: 'agents/buyBDTLOffers',
      setFreeBDTLOffers: 'agents/setFreeBDTLOffers'
    }),
    checkAgentPermission () {
      if (!this.isUserBDTLAgent) {
        this.$router.push({ name: 'profile' }).catch(() => {})
      }
    },
    getPackageById (id) {
      return this.packageById(id) ? this.packageById(id).name : ''
    },
    async getList () {
      try {
        this.getListLoading = true
        await this.fetchOffersList()
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
      } finally {
        this.getListLoading = false
      }
    },
    selectOffer (item) {
      this.currentOfferPrice = item.price
      this.packageOfferId = item.id
      this.packageId = item.packageId
      this.count = 1
      this.totalAmount = this.count * this.currentOfferPrice
      this.changeStep(2)
    },
    setCount () {
      this.changeStep(3)
    },
    changeStep (step) {
      this.errorResp = null
      this.name = null
      this.number = false
      this.expiry = false
      this.cvc = false
      this.$v.$reset()
      this.step = step
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    moveFocus () {
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus()
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      }
    },
    changePreviousStep (step) {
      this.step = step
    },
    async onSubmit () {
      try {
        this.errorResp = null
        this.loading = true
        const data = {
          packageOfferId: this.packageOfferId,
          packageOfferAmount: this.count,
          packageId: this.packageId,
          name: this.name,
          request: false
        }
        await this.buyBDTLOffers(data)
        this.$modal.show('success')
        this.resetData()
        this.$router.push({ name: 'bdtl-cabinet' }).catch(() => {})
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
        if (e.response.data.data.packageOfferAmount) {
          this.errorResp = this.$t('quantityNotAllowed')
        }
        if (e.response.data.data.packageOfferId) {
          this.errorResp = this.$t('expiredOffer')
        }
      } finally {
        this.loading = false
      }
    },
    resetData () {
      this.step = 1
      this.count = 1
      this.packageOfferId = null
      this.packageOfferAmount = null
      this.name = null
    },
    decrementCount () {
      if (this.count > 0) {
        this.count -= 1
      }
    },
    incrementCount () {
      if (this.count < 1000) {
        this.count += 1
      }
    },
    setNextStep (step) {
      this.step = step
    },
    goToOffers () {
      this.step = 1
      this.count = 1
      this.totalAmount = 0
    },
    updateCount () {
      if (this.count < 1000) {
        this.count = parseInt(this.count)
      } else {
        this.count = 1000
      }
    },
    async getFreeOffer () {
      try {
        this.errorResp = null
        this.loading = true
        const data = {
          packageOfferId: this.packageOfferId,
          packageOfferAmount: this.count,
          packageId: this.packageId,
          request: true
        }
        await this.setFreeBDTLOffers(data)
        this.$modal.show('success')
        this.resetData()
        this.$router.push({ name: 'bdtl-cabinet' }).catch(() => {})
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e)
        if (e.response.data.data.packageOfferAmount) {
          this.errorResp = this.$t('quantityNotAllowed')
        }
        if (e.response.data.data.packageOfferId) {
          this.errorResp = this.$t('expiredOffer')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.store {
  &-empty {
    display: flex;
    justify-content: center;
    padding: 50px 0;
    svg{
      width: 80px;
      @include respondTo(600px){
        width: 60px;
      }
    }
  }
  &-wrap {
    padding: 30px;
    margin: 0 auto;
  }
  &-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 40px;
  }
  &-list {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    max-width: 1000px;
    margin: 0 auto;
  }
  &-packages {
    position: relative;
    &__loader{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: #f2f2f2;
      z-index: 3;
    }
  }
  &-steps {
    margin-bottom: 50px;
    @include respondTo(600px){
      margin-bottom: 20px;
    }
    &__list {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      overflow: hidden;
    }
    &__item {
      font-size: 16px;
      line-height: 1;
      font-weight: bold;
      color: $black;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      background: #cecece;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      transition: background $trans, color $trans;
      &.active{
        background: #00b764;
        color: $white;
      }
      &:not(:first-child) {
        margin-left: 90px;
        @include respondTo(600px){
          margin-left: 50px;
        }
        @include respondTo(600px){
          margin-left: 30px;
        }
        &:after {
          content: '';
          display: block;
          width: 90px;
          height: 1px;
          position: absolute;
          left: -90px;
          top: 50%;
          transform: translateY(-50%);
          background: #cecece;
          transition: background $trans;
          @include respondTo(600px){
            left: -50px;
            width: 50px;
          }
          @include respondTo(600px){
            left: -30px;
            width: 30px;
          }
        }
      }
      &.active:after {
        background: #00b764;
      }
    }
    &__title {
      text-align: center;
      font-size: 14px;
      line-height: 1.3;
      font-weight: bold;
      span {
        display: block;
        margin-top: 10px;
        font-size: 12px;
      }
      strong {
        color: #00b764;
      }
    }
  }
  &-form {
    max-width: 300px;
    margin: 0 auto;
    .InputContainer input {
      width: 100px;
      height: 30px;
      border: 1px solid #000;
    }
    label {
      font-size: 16px;
      font-weight: 500;
      .stripe-input {
        margin-top: 10px;
      }
    }
    &__row {
      &:not(:first-child) {
        margin-top: 15px;
      }
    }
    &__action {
      margin-top: 30px;
      display: flex;
      flex-direction: column-reverse;
      justify-content: center;
      align-items: center;
      .button--disabled {
        opacity: 0.4;
      }
      &-back {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        text-align: center;
        text-decoration: underline;
        font-size: 16px;
        line-height: 1.2;
      }
    }
    &__count {
      display: flex;
      justify-content: center;
      align-items: center;
      button {
        font-size: 34px;
        line-height: 1.3;
        font-weight: bold;
        cursor: pointer;
        color: #00b764;
        user-select: none;
      }
      input[type=number] {
        margin: 0 15px;
      }
      input {
        background: transparent;
        width: 60px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        border: 1px solid #00b764;
        font-size: 16px;
        padding: 0 10px;
      }
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type=number] {
        -moz-appearance: textfield;
      }
    }
    &__next {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 50px auto 10px;
      border-radius: 8px;
      background: #00b764;
      color: $white;
      font-weight: bold;
      cursor: pointer;
      transition: background $trans;
      &:hover {
        background: #00cb71;
      }
      &:disabled {
        background: #cecece;
        pointer-events: none;
        user-select: none;
      }
    }
    &__radio {
      max-width: 600px;
      margin: 0 auto;
      &-list {
        padding: 20px 0;
        div {
          padding: 10px 0;
          font-size: 18px;
          user-select: none;
        }
        svg {
          width: 18px;
          height: 18px;
          margin-left: 10px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }
  .form--error{
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
  }
  .store-form__back {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .back-button {
    padding: 10px 25px;
    text-decoration: none;
    border-radius: 8px;
    background: #00b764;
    color: $white;
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;
    svg {
      vertical-align: middle;
      width: 20px;
      height: 20px;
      margin-right: 10px;
    }
  }
  &-finish {
    max-width: 250px;
    margin: 0 auto;
    .store-form__back,
    button {
      width: 100%;
      a {
        width: 100%;
        height: 46px;
      }
    }
  }
  .store-form__action {
    .store-form__back a{
      width: 195px;
    }
  }
}
</style>
